export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.5-1200.10",
  commitId: "188b15417dcd2b8b85f4b4cd8a0fdc2d1b4b20b6",
  commitTime: "2026-10-05T12:00:10.000Z",
});
